<template>
  <v-row v-if="lodash.isEmpty(groupedTreatments)" justify="center">
    <v-col cols="6">
      <v-alert color="orange" outlined text type="info">
        Sem tratamentos
      </v-alert>
    </v-col>
  </v-row>

  <v-row v-else dense>
    <v-col>
      <v-row
        v-for="(filteredTreatments, treatmentName) in groupedTreatments"
        :key="treatmentName"
      >
        <v-col>
          <v-row dense>
            <v-col class="text-h5 gray--text text--lighten-1">
              {{ treatmentName }}
            </v-col>
          </v-row>

          <v-row dense v-for="(treatment, index) in filteredTreatments" :key="treatment.id">
            <v-col>
              <TreatmentListItem
                :attendance="attendance"
                :treatment="treatment"
                :index="index"
                :refreshList="refreshList"
                :allowEdit="allowEdit"
                :allowDelete="allowDelete"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
  import TreatmentListItem from "@/components/treatment/list/item.vue";

  export default {
    name: "TreatmentList",
    props: {
      attendance: Object,
      allowEdit: {
        type: Boolean,
        default: true,
      },
      allowDelete: {
        type: Boolean,
        default: true,
      },
    },
    components: {
      TreatmentListItem,
    },
    apollo: {
      treatments: {
        query: require("@/graphql/treatment/treatments.gql"),
        variables() {
          return {
            attendanceId: this.attendance.id,
          };
        },
        update(data) {
          return this.lodash.orderBy(data.treatments, ["executedAt"], ["desc"]);
        },
        pollInterval: 20000,
      },
    },
    computed: {
      groupedTreatments() {
        const unordered = this.lodash.groupBy(this.treatments, "treatmentTemplate.name");
        const ordered = {};
        Object.keys(unordered)
          .sort()
          .forEach(function(key) {
            ordered[key] = unordered[key];
          });
        return ordered;
      },
    },
    methods: {
      refreshList() {
        this.$apollo.queries.treatments.refetch();
      },
    },
  };
</script>

<style lang="scss" scoped></style>
